import React from 'react'
import ReactSelect from "react-select";

const SelectInput = (props) => {
 const {label ,placeholder ,name ,note ,value,handleSelect  ,options , } = props
  return (

   <div className='input__box'>
      <label htmlFor='en_name' className='input__label'>
        {label}
      </label>
     <ReactSelect
       placeholder={placeholder}
       options={options}
       name={name}
       onChange={handleSelect}
       value={value}
       note={note}
     />

   </div>

  )
}

export default SelectInput

